export class ChartLineOptions{

    public static id = 'line';
    public static fill = false;

    public static getOptions() : any {

        return {
            responsive: true,
            maintainAspectRatio: true,
            legend: {
                display: false,
            },
            scales: {
                // The following will affect the vertical lines (xAxe) of your dataset
                xAxes: [{
                    gridLines: {
                        // You can change the color, the dash effect, the main axe color, etc.
                        drawBorder: false,
                        drawTicks: true,
                        display: false,
                        color: "#ffffff",
                    }
                }],

                // And this will affect the horizontal lines (yAxe) of your dataset
                yAxes: [{
                    gridLines: {
                        drawBorder: false,
                        borderDash: [1, 25],
                        color: "rgba(255, 255, 255, 0.4)",
                        drawOnChartArea: true,
                        drawTicks: false,
                        zeroLineWidth: 1,
                        zeroLineColor: 'rgba(255, 255, 255, 0.4)',
                        zeroLineBorderDash: [1, 25],
                        zeroLineBorderDashOffset: 0.0,
                    },
                    ticks: {
                        padding: 5
                    }
                }]
            }
        }
    };

    public static getAdditionalData() : any{
        return {
            datasets: {
                pointRadius: 0,
                borderWidth: 1
            }
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/model/options-type/chart-line-options.ts